import { KybRetentionAction } from "@/core/kyb/entities/KybRetention";

// Chemins relatifs à la base `/api/v1` du client HTTP.
const base = "/compliance/kyb";

/** Chemin de chaque décision ; `switch` plutôt qu'accès `objet[clé]` (faux positif `detect-object-injection`). */
function decisionPath(action: KybRetentionAction): string {
  switch (action) {
    case "EXTEND":
      return "extension";
    case "HOLD":
      return "legal-hold";
    case "RELEASE":
      return "legal-hold/release";
    case "REQUEST_DELETION":
      return "deletion-request";
    case "AUTHORIZE_DELETION":
      return "deletion-authorization";
  }
}

const kybRetentionEndpoints = {
  register: (days: number, limit: number) => `${base}/retention?dueWithinDays=${days}&limit=${limit}`,
  caseRetention: (caseId: string) => `${base}/legal-entity-cases/${caseId}/retention`,
  decision: (caseId: string, action: KybRetentionAction) =>
    `${base}/legal-entity-cases/${caseId}/retention/${decisionPath(action)}`,
};

export default kybRetentionEndpoints;
